/* <!-- Legal templates pending review by qualified counsel before production --> */
/* Internal note: verify each control above matches the implemented system before publishing. */
import { HELP_EMAIL } from "@/constants/links";

import { LEGAL_LAST_UPDATED } from "./legalDate";
import LegalShell from "./LegalShell";

export default function Security() {
    return (
        <LegalShell
            title="Security"
            lastUpdated={LEGAL_LAST_UPDATED}
            testId="security-page"
        >
            <p className="core-legal-lede">
                At C-ORE C-Suites, safeguarding your business data is
                foundational to everything we build.
            </p>

            <section className="core-legal-section">
                <h2>Data security</h2>
                <p>
                    We apply layered controls across the application,
                    network and storage, with anomaly detection and
                    alerting on unusual activity.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Encryption</h2>
                <p>
                    Data is encrypted in transit using TLS and encrypted
                    at rest on our servers.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Access controls</h2>
                <p>
                    Role-based access limits who can see what; you control
                    which users and which CA/accountant can access your
                    data, and can revoke access at any time. Sensitive
                    actions are recorded in audit trails.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Infrastructure protections</h2>
                <p>
                    The platform runs on access-controlled, multi-region
                    infrastructure with regular encrypted backups and
                    routine security maintenance.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Responsible disclosure</h2>
                <p>
                    If you believe you have found a security vulnerability,
                    please report it to{" "}
                    <a
                        href={`mailto:${HELP_EMAIL}`}
                        data-testid="security-disclosure-email"
                    >
                        {HELP_EMAIL}
                    </a>{" "}
                    and allow us reasonable time to investigate and respond
                    before public disclosure.
                </p>
            </section>
        </LegalShell>
    );
}
